import * as DOMPurify from 'dompurify'

async function addStockMessaging () {
  if (window.theme.settings.template !== 'product.supadu') return
  // If no product price due to data issues, no need to show any stock message
  if (!window.theme.productData.price) return
  try {
    const productFormInner = document.querySelector('.product-form__inner')
    if (!productFormInner) return
    const item = window.theme.staticProductData
    if (!item) return
    const { isbn13, title } = item
    const requestUrl = `https://staging-add-to-cart.supadu.com/add-to-cart?action=availability&isbn=${isbn13}&client=indiepubs-dev-us&response=json`
    const response = await fetch(requestUrl)
    const responseJSON = await response.json()
    // TODO apply all this logic to indiepubs-us.js once confirmed
    const { msg, show, published, error } = responseJSON
    if (responseJSON.msg) {
      const stockMessage = `
        <div class="indiepubs-stock-message">
          <span>
            <strong>${msg}</strong>
          </span>
        </div>
      `
      productFormInner.insertAdjacentHTML('afterend', stockMessage)
    }

    const currentFormat = item.formats.find(format => format.isbn === isbn13)
    if (!currentFormat || !currentFormat.format || !currentFormat.format.code) return
    const buyForm = document.querySelector('.js-product-single__form')
    if (!buyForm) return

    let showNotifyMe = false
    let showCurrentlyUnavailable = false

    // eBook logic
    if (currentFormat.format.code === 'DG') {
      if (!published) {
        showNotifyMe = true
      } else if (!show) {
        showCurrentlyUnavailable = true
      }
    } else {
    // non-eBook logic
      if (!show || error) showNotifyMe = true
    }

    if (showCurrentlyUnavailable) {
      buyForm.style.display = 'flex'
      buyForm.innerHTML = `
        <button
          type="button"
          name="add"
          class="btn btn--full add-to-cart"
          disabled="disabled"
        >
          Currently Unavailable
        </button>
      `
    } else if (showNotifyMe) {
      buyForm.style.display = 'flex'
      buyForm.innerHTML = `
        <a href="/pages/notify-me?title=${title}&isbn=${isbn13}" class="btn btn--full add-to-cart" target="_blank">
          Notify Me When Available
        </a>
      `
    }
  } catch (e) {
    // console.log(e)
  }
}

async function getCartLogo () {
  if (window.theme.settings.template !== 'cart') return

  const url = new URL(window.location)
  const requestUrl = `${url.origin}/cart.json`
  const response = await fetch(requestUrl)

  if (response.status !== 200) return

  const responseJSON = await response.json()

  if (!responseJSON.attributes || !responseJSON.attributes.logo) return

  const attributes = responseJSON.attributes

  const cleanString = DOMPurify.sanitize(attributes.logo.replace(/<\/?[^>]+(>|$)/g, '').replace(/\.[^.]+$/, ''))
  const cleanLink = `${url.origin}/redirect/${cleanString}`

  const logoHTML = `<div class="client-logo"><a href="${cleanLink}" target="_blank" title="Go to ${cleanString} site"><img src="https://supadu-io.imgix.net/smart-buy-buttons/covers/${cleanString}.png?auto=format"></a><p>Our checkout is powered by IndiePubs, the online bookstore for Independent Publishers.</p></div>`
  const container = document.querySelector('.section-header')
  container.insertAdjacentHTML('afterbegin', logoHTML)

  const continueShoppingBtn = `<a href="${url.origin}/redirect/${cleanString}" class="btn btn--secondary cart__update continue__shopping" title="Continue Shopping">Continue Shopping</a>`
  const updateCartBtn = document.querySelector('.cart__update')
  updateCartBtn.insertAdjacentHTML('afterend', continueShoppingBtn)
}

function addResetPasswordLink () {
  if (window.theme.settings.template !== 'customers/account') return
  const pageTitle = document.querySelector('.section-header__title')
  if (!pageTitle) return
  const resetLink = '<a href="/account/login#recover" class="btn btn--secondary btn--small section-header__link" style="margin-right: 8px;">Reset Password</a>'
  pageTitle.insertAdjacentHTML('afterend', resetLink)
}

function hidePageTitles () {
  if (window.theme.settings.template !== 'page') return
  const paths = [
    '/pages/book-is-out-of-stock',
    '/pages/book-not-available-to-purchase',
    '/pages/book-is-not-yet-available',
    '/pages/notify-me'
  ]
  if (paths.includes(window.location.pathname)) {
    const title = document.querySelector('.section-header__title')
    title.style.display = 'none'
  }
}

function notifyMePageLogic () {
  if (
    window.theme.settings.template !== 'page' ||
    !window.location.pathname.includes('/pages/notify-me')
  ) return

  const urlParams = new URLSearchParams(window.location.search)
  const title = urlParams.get('title')
  const isbn = urlParams.get('isbn')
  if (!title && !isbn) return

  const pageHeader = document.querySelector('.section-header')
  if (!pageHeader) return

  pageHeader.insertAdjacentHTML('afterend', `
    <div>
      <h3>Book Details:</h3>
      <p><strong>Title</strong>: ${title}</p>
      <p><strong>ISBN</strong>: ${isbn}</p>
    </div>
  `)
}

function observeCartChanges (cartChangeAction) {
  const cartObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType)
      const isCartChangeRequest = /\/cart\//.test(entry.name)
      if (isValidRequestType && isCartChangeRequest) {
        cartChangeAction()
      }
    })
  })
  cartObserver.observe({ entryTypes: ['resource'] })
}

function addBulkEbookMessagingProductPage () {
  if (window.theme.settings.template !== 'product.supadu') return
  const item = window.theme.staticProductData
  if (!item) return
  const { isbn13 } = item
  const currentFormat = item.formats.find(format => format.isbn === isbn13)
  if (!currentFormat || currentFormat.format.code !== 'DG') return

  async function ebookCheck () {
    try {
      const productFormInner = document.querySelector('.product-form__inner')
      if (!productFormInner) return
      const cartResponse = await window.theme.cart.getCart()
      const { items } = cartResponse
      if (!items || !items.length) return
      const matchingBulkItem = items.some(item => {
        return item.sku === isbn13 && item.quantity > 1
      })
      const bulkMessageElement = document.querySelector('.indiepubs-bulk-message')
      if (!matchingBulkItem) {
        if (!bulkMessageElement) return
        bulkMessageElement.remove()
        return
      }
      if (bulkMessageElement) return
      const bulkMessage = `
        <div class="indiepubs-bulk-message">
          <span>
            <strong>You are purchasing this item in bulk</strong>
          </span>
        </div>
      `
      productFormInner.insertAdjacentHTML('afterend', bulkMessage)
    } catch (e) {
      console.log(e)
    }
  }

  ebookCheck()
  observeCartChanges(ebookCheck)
}

function addBulkEbookMessagingCartPage () {
  if (window.theme.settings.template !== 'cart') return

  function ebookCheck () {
    const cart = document.querySelector('.cart')
    if (!cart) return
    const cartRows = cart.querySelectorAll('.cart__row')
    if (!cartRows || !cartRows.length) return
    let bulkEbooksInCart = false
    cartRows.forEach(row => {
      const format = row.querySelector('.cart__product-meta')
      const itemQuantity = row.querySelector('.cart__product-qty')
      if (!format || !itemQuantity) return
      if ((format.innerHTML.includes('eBook') || format.innerHTML.includes('EPUB')) && itemQuantity.value > 1) {
        bulkEbooksInCart = true
      }
    })
    const bulkMessageElement = document.querySelector('.indiepubs-bulk-message')
    if (!bulkEbooksInCart) {
      if (!bulkMessageElement) return
      bulkMessageElement.remove()
      return
    }
    if (bulkMessageElement) return
    const bulkMessage = `
      <h3 class="indiepubs-bulk-message">
        You are purchasing eBooks in bulk
      </h3>
    `
    cart.insertAdjacentHTML('beforebegin', bulkMessage)
  }

  ebookCheck()
  observeCartChanges(ebookCheck)
}

function customFunctions () {
  addStockMessaging()
  addResetPasswordLink()
  getCartLogo()
  hidePageTitles()
  notifyMePageLogic()
  addBulkEbookMessagingProductPage()
  addBulkEbookMessagingCartPage()
}

module.exports = { customFunctions }
